import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { BrandDnaiLogo } from '@assets/icons';
import SwitchWorkspaceForm from '@pages/select-workspace/components/SwitchWorkspaceForm';
import { AppRoutes } from '@routes/constants';
import { cachedPageUrlAtom } from '@store/atoms/cached-page-url';
import { customerAtom } from '@store/atoms/customer';
import { workspaceAtom } from '@store/atoms/workspace';

import SettingsOption from './settings-option/SettingsOption';

const SideNav = () => {
  const customerData = useRecoilValue(customerAtom);

  const currentWorkspace = useRecoilValue(workspaceAtom);

  const cachedPageUrl = useRecoilValue(cachedPageUrlAtom);

  return (
    <div className="w-[200px] min-w-[200px] h-screen flex flex-col justify-between py-6 pl-5 border-r border-gray-6">
      <div className="flex flex-col">
        <Link
          to={{
            pathname: `/${currentWorkspace?.uuid}${AppRoutes.BRAND_LIBRARY}`,
            search: cachedPageUrl,
          }}
          className="flex justify-center items-center pr-5"
        >
          {customerData?.metadata?.logoUrl ? (
            <img
              src={customerData.metadata.logoUrl}
              alt="Brand-DNAI logo"
              className="h-14 "
            />
          ) : (
            <BrandDnaiLogo className="h-9 w-40 flex justify-center items-center pr-5" />
          )}
        </Link>
        <div className="mt-8 mb-4 font-bold text-md text-dark-2">Workspace</div>
        <SwitchWorkspaceForm />
      </div>
      <div className="flex flex-col gap-4">
        <SettingsOption />
      </div>
    </div>
  );
};

export default SideNav;
